import styled from "styled-components"
import {minWidthMedia} from "@irati/ui/src/global/media"
import padding from "@irati/ui/src/global/padding"

export default styled.div`
  position: relative;
  padding: 0 5px;

  ${minWidthMedia.tablet`
    padding: 0 ${padding.tiny};
  `}
`
